import { createContext } from 'react';

const provinciaContext = createContext();

export default provinciaContext;